import { IconArrowDown } from '@/icons/IconArrowDown';
import { components } from 'react-select';

const ReactSelectComponents = ({
  focus,
  open,
  unstyled,
  hasLabel = false,
}: {
  focus: boolean;
  open: boolean;
  unstyled?: boolean;
  hasLabel?: boolean;
}) => {
  return {
    SelectContainer: ({ children, className, ...rest }: any) => {
      return (
        <components.SelectContainer
          className={`select-container ${unstyled ? '' : 'field-group'} flex ${hasLabel ? 'labeled' : ''} ${rest.isFocused ? 'focus' : ''} ${rest.selectProps.menuIsOpen ? '!rounded-b-none' : ''} ${className}`}
          {...rest}
        >
          {children}
        </components.SelectContainer>
      );
    },
    Control: ({ children, className, ...rest }: any) => {
      return (
        <components.Control
          className={`control flex !min-h-[unset] w-full ${unstyled ? '' : 'form-field'} ${hasLabel ? 'labeled' : ''} ${className}`}
          {...rest}
        >
          {children}
        </components.Control>
      );
    },
    DropdownIndicator: (props: any) => {
      return (
        <components.DropdownIndicator
          {...props}
          className={`ml-2 ${hasLabel ? '-translate-y-3' : ''} ${props.selectProps.menuIsOpen ? 'rotate-180' : ''}`}
        >
          <IconArrowDown className="w-5" />
        </components.DropdownIndicator>
      );
    },
    Menu: ({ children, className, style, ...rest }: any) => {
      return (
        <components.Menu
          className={`left-[-1px] !w-[calc(100%+2px)] min-w-fit overflow-y-auto overflow-x-hidden border bg-white py-1.5 shadow-lg ${unstyled ? 'rounded-lg border-gray-200' : 'rounded-[5px] border-gray-400'} ${rest.placement === 'top' ? 'rounded-b-none border-b-0' : 'rounded-t-none'} ${className}`}
          {...rest}
        >
          {children}
        </components.Menu>
      );
    },
    MenuList: ({ className, children, ...rest }: any) => {
      return (
        <components.MenuList className={`menu-list !max-h-80 min-w-fit ${className}`} {...rest}>
          {children}
        </components.MenuList>
      );
    },
    Option: ({ children, className, isSelected, isFocused, ...rest }: any) => {
      return (
        <components.Option
          className={`!cursor-pointer whitespace-nowrap px-6 transition-all duration-200 hover:bg-orange-100 ${unstyled ? 'py-2' : 'py-3'} ${isFocused ? 'bg-orange-100' : ''} ${isSelected ? '!bg-black text-white' : ''} ${className}`}
          {...rest}
        >
          {children}
        </components.Option>
      );
    },
  };
};

export default ReactSelectComponents;
